import React, { useState } from "react";
import classNames from "classnames";

export const Alert = (props) => {
  const [visible, setVisible] = useState(props.visible || false);

  const primary = props.type === "primary" || !props.type;
  const danger = props.type === "danger";
  const success = props.type === "success";
  const warning = props.type === "warning";
  const dark = props.type === "dark";

  const wrapperClasses = classNames(
    ////////// WRAPPER
    "flex p-4 rounded",
    // BLUE
    { "bg-blue-100 dark:bg-blue-200": primary },
    // RED
    { "bg-red-100 dark:bg-red-200": danger },
    // GREEN
    { "bg-green-100 dark:bg-green-200": success },
    // YELLOW
    { "bg-yellow-100 dark:bg-yellow-200": warning },
    // DARK
    { "bg-gray-100 dark:bg-gray-700": dark }
  );

  const svgClasses = classNames(
    ////////// SVG
    "flex-shrink-0 w-5 h-5",
    // BLUE
    { "text-blue-700 dark:text-blue-800": primary },
    // RED
    { "text-red-700 dark:text-red-800": danger },
    // GREEN
    { "text-green-700 dark:text-green-800": success },
    // YELLOW
    { "text-yellow-700 dark:text-yellow-800": warning },
    // DARK
    { "text-gray-700 dark:text-gray-300": dark }
  );

  const bodyClasses = classNames(
    ////////// BODY
    "ml-3 text-sm font-medium",
    // BLUE
    { "text-blue-700 dark:text-blue-800": primary },
    // RED
    { "text-red-700 dark:text-red-800": danger },
    // GREEN
    { "text-green-700 dark:text-green-800": success },
    // YELLOW
    { "text-yellow-700 dark:text-yellow-800": warning },
    // DARK
    { "text-gray-700 dark:text-gray-300": dark }
  );

  const closeClasses = classNames(
    ////////// CLOSE
    "ml-auto -mx-1.5 -my-1.5 rounded focus:ring-2 h-8 w-8 inline-flex",
    // BLUE
    {
      "bg-blue-100 text-blue-500 focus:ring-blue-400 p-1.5 hover:bg-blue-200":
        primary,
    },
    // RED
    {
      "bg-red-100 text-red-500 focus:ring-red-400 p-1.5 hover:bg-red-200":
        danger,
    },
    // GREEN
    {
      "bg-green-100 text-green-500 focus:ring-green-400 p-1.5 hover:bg-green-200":
        success,
    },
    // YELLOW
    {
      "bg-yellow-100 text-yellow-500 focus:ring-yellow-400 p-1.5 hover:bg-yellow-200":
        warning,
    },
    // DARK
    {
      "bg-gray-100 text-gray-500 focus:ring-gray-400 p-1.5 hover:bg-gray-200":
        dark,
    }
  );

  function handleClose() {
    props.handleClose(false);
    setVisible(false);
  }

  return (
    visible && (
      <div id="alert-1" className={wrapperClasses} role="alert">
        <svg
          aria-hidden="true"
          className={svgClasses}
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
            clipRule="evenodd"
          ></path>
        </svg>
        <span className="sr-only">Info</span>
        <div className={bodyClasses}>{props.body}</div>
        <button
          type="button"
          className={closeClasses}
          data-dismiss-target="#alert-1"
          aria-label="Close"
          onClick={handleClose}
        >
          <span className="sr-only">Close</span>
          <svg
            aria-hidden="true"
            className="w-5 h-5"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clipRule="evenodd"
            ></path>
          </svg>
        </button>
      </div>
    )
  );
};

export default Alert;
